export default "__VITE_ASSET__Dj36iYZ6__"